"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _injectSheet = _interopRequireDefault(require("../../style/injectSheet"));
var _excluded = ["status", "classes", "circular", "image", "badgeCount", "className", "avatarClassName", "title", "theme"];
/*:: import { type ThemeType, type InjectSheetProvidedProps } from '../../style/ThemeTypes';*/
var Style = function Style(theme /*: ThemeType*/) {
  return {
    root: {
      display: 'inline-block',
      position: 'relative',
      width: '2.5rem',
      height: '2.5rem'
    },
    avatar: {
      overflow: 'hidden',
      display: 'inline-block',
      width: '100%',
      height: '100%'
    },
    circular: {
      borderRadius: '50%'
    },
    image: {
      maxWidth: '100%'
    },
    badgeCount: {
      fontSize: '.6rem',
      borderRadius: '50%',
      background: theme.colors.white,
      color: theme.colors.pebbleGrey,
      border: "1px solid ".concat(theme.colors.lightGrey),
      position: 'absolute',
      top: 0,
      right: '-.25rem',
      width: '1.45rem',
      height: '1.45rem',
      textAlign: 'center',
      display: 'flex',
      alignSelf: 'flex-end',
      lineHeight: '1.5rem',
      fontWeight: 400,
      alignItems: 'center',
      letterSpacing: '-0.006rem',
      justifyContent: 'center'
    },
    badgeCountLarge: {
      backgroundColor: theme.colors.dullRed,
      color: theme.colors.white
    }
  };
};
/*:: type Props = InjectSheetProvidedProps &
  HTMLSpanElement & {
    image: string,
    circular?: boolean,
    title: string,
    badgeCount: number,
    avatarClassName: string
  };*/
var Avatar = function Avatar(_ref /*:: */) {
  var status = _ref /*:: */.status,
    classes = _ref /*:: */.classes,
    circular = _ref /*:: */.circular,
    image = _ref /*:: */.image,
    badgeCount = _ref /*:: */.badgeCount,
    className = _ref /*:: */.className,
    avatarClassName = _ref /*:: */.avatarClassName,
    title = _ref /*:: */.title,
    theme = _ref /*:: */.theme,
    props = (0, _objectWithoutProperties2.default)(_ref /*:: */, _excluded);
  return /*#__PURE__*/_react.default.createElement("span", (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, className)
  }, props), /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _classnames.default)(classes.avatar, (0, _defineProperty2.default)({}, classes.circular, circular), avatarClassName)
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: image,
    alt: title,
    title: title,
    className: classes.image
  })), badgeCount && /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _classnames.default)(classes.badgeCount, (0, _defineProperty2.default)({}, classes.badgeCountLarge, badgeCount > 99))
  }, badgeCount > 99 ? '99+' : badgeCount));
};
Avatar.displayName = 'Avatar';
Avatar.defaultProps = {
  circular: true
};
var _default = exports.default = (0, _injectSheet.default)(Style)(Avatar);
//# sourceMappingURL=Avatar.js.map